import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, createQueryKey, useAxiosClient, useQuery } from '@lumahealthhq/ui-model';
var basePath = 'customWebStyles';
var crud = createCrud(basePath);

/* Default queries */
export var useCustomWebStyleOne = crud.makeFindOne();
export var useCustomWebStyleMany = crud.makeFindMany('{basePath}');

/**
 * @deprecated Use useCustomWebStyleOne or useCustomWebStyleMany instead
 */
export function useCustomWebStyles() {
  var axiosClient = useAxiosClient();
  var variant = 'v2/{basePath}';
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response$data;
      var response, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.get(basePath);
          case 2:
            response = _context.sent;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            data = ((_response$data = response.data) == null ? void 0 : _response$data.response) || response.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, variant);
  var query = useQuery(queryKey, queryFn);
  return query;
}